import escConstants from "../constants";
import { NoLayout, PrivateLayout, PublicLayout } from "../layouts";
import { PrivateLayoutWithNoSidebar } from "../layouts/Layout";
import {
  AddPrinter,
  BrowseJobs,
  BrowseJobsDetails,
  CreateJobs,
  CreateNewJobs,
  CreateProposal,
  Dashboard,
  DownloadTemplate,
  ForgetPassword,
  JobDetails,
  Jobs,
  Login,
  Logout,
  Message,
  MyJobs,
  NotFound404,
  OnBoarding,
  Printer,
  Proposals,
  Schedule,
  Services,
  Settings,
  Test,
  VerificationCode,
  ViewBuildingDetails,
  ViewCreatedJobs,
  ViewMyJobs,
} from "../pages";
import AboutUs from "../pages/AboutUs";
import AdminPricing from "../pages/AdminPricing";
import AddPricing from "../pages/AdminPricing/AddPricing";
import ViewPricing from "../pages/AdminPricing/ViewPricing";
import ChangePassword from "../pages/Auth/ForgetPassword/ChangePassword";
import Register from "../pages/Auth/Register";
import Building from "../pages/Building";
import AddBuilding from "../pages/Building/AddBuilding";
import ClientContract from "../pages/ClientContract";
import ClientContractDetails from "../pages/ClientContract/ContractDetails";
import CompletePDF from "../pages/CompletePDF";
import ContactUs from "../pages/ContactUs";
import Contract from "../pages/Contract";
import ContractDetails from "../pages/Contract/ContractDetails";
import DownloadSymbols from "../pages/DownloadSymbols";
import ViewTemplateDetails from "../pages/DownloadTemplate/ViewTemplateDetails";
import DraftsJob from "../pages/DraftsJob";
import ViewJob from "../pages/DraftsJob/ViewJob";
import Faqs from "../pages/Faqs";
import PrinterHistory from "../pages/History";
import LandingPage from "../pages/LandingPage";
import Notifications from "../pages/Notifications";
import Pricing from "../pages/Pricing";
import PrinterClientList from "../pages/PrinterClient";
import PrinterClientDetails from "../pages/PrinterClient/PrinterClientDetails";
import PrinterJob from "../pages/PrinterJobs";
import PrinterJobDetails from "../pages/PrinterJobs/PrinterJobDetails";
import JobProposals from "../pages/Proposals/JobProposal";
import ProposalForTechnician from "../pages/Proposals/ViewProposal/ProposalForTechnician";
import Reviews from "../pages/Reviews";
import PDFDetail from "../pages/Reviews/PdfDetail";
import ViewReviews from "../pages/Reviews/ViewReviews";
import Country from "../pages/Settings/Admin/Country";
import Invoices from "../pages/Settings/Admin/invoices";
import SingleInvoice from "../pages/Settings/Admin/invoices/ViewInvoices";
import Rules from "../pages/Settings/Admin/Rules";
import Symbols from "../pages/Symbols";
import AddSymbol from "../pages/Symbols/AddSymbol";
import TechnicianProposals from "../pages/TechnicianProposals";
import ViewProposal from "../pages/TechnicianProposals/ViewProposal";
import Technicians from "../pages/Technicians";
import TechnicianDetail from "../pages/Technicians/TechnicianDetail";
import Templates from "../pages/Templates";
import AddTemplate from "../pages/Templates/AddTemplate";
import Users from "../pages/Users";
import CreateUser from "../pages/Users/CreateUser";
import UserDetails from "../pages/Users/UserDetails";
import {
  ABOUT_US_ROUTE,
  ADD_BUILDING_ROUTE,
  ADD_JOBS_ROUTE,
  ADD_PRICING_ROUTE,
  ADD_PRINTER_ROUTE,
  ADD_SYMBOL_ROUTE,
  ADD_TEMPLATE_ROUTE,
  ADD_USER_ROUTE,
  ADMIN_COUNTRY,
  ADMIN_INVOICES,
  ADMIN_INVOICES_VIEW,
  ADMIN_PRICING_ROUTE,
  ADMIN_RULES,
  BROWSE_JOBS_ROUTE,
  BUILDING_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  COMPLETE_PDF_ROUTE,
  CONTACT_US_ROUTE,
  CONTRACT_DETAIL_ROUTE_CLIENT,
  CONTRACT_DETAILS_ROUTE,
  CONTRACT_ROUTE,
  CONTRACT_ROUTE_CLIENT,
  CREATE_JOB_PROPOSAL_ROUTE,
  CREATE_JOBS_ROUTE,
  DASHBOARD_ROUTE,
  DOWNLOAD_SYMBOLS_ROUTE,
  DOWNLOAD_TEMPLATE_ROUTE,
  DRAFTS_JOB,
  FAQS_ROUTE,
  FORGOT_ROUTE,
  HOME_ROUTE,
  JOBS_DETAILS_ROUTE,
  JOBS_ROUTE,
  LOG_OUT_ROUTE,
  LOGIN_ROUTE,
  MESSAGE_ROUTE,
  MY_JOBS_ROUTE,
  NOT_FOUND_ROUTE,
  ONBOARDING_CURRENT_STEP_ROUTE,
  ONBOARDING_ROUTE,
  PRICING_ROUTE,
  PRINTER_ROUTE,
  PROPOSAL_ROUTE,
  REGISTER_ROUTE,
  REVIEW_PDF,
  REVIEW_ROUTE_ADMIN,
  SCHEDULE_ROUTE,
  SERVICES_ROUTE,
  SETTING_ROUTE,
  SINGLE_TECHNICIAN_ROUTE,
  SYMBOL_ROUTE,
  TECHNICIAN_PROPOSAL_ROUTE,
  TECHNICIAN_ROUTE,
  TEMPLATE_ROUTE,
  TEST_ROUTE,
  USER_DETAIL_ROUTE,
  USER_ROUTE,
  VERIFICATION_ROUTE,
  VIEW_BROWSE_JOBS_ROUTE,
  VIEW_BUILDING_ROUTE,
  VIEW_DRAFT_JOB_ROUTE,
  VIEW_JOBS_ROUTE,
  VIEW_MY_JOBS_ROUTE,
  VIEW_MY_NOTIFICATIONS,
  VIEW_PARTICULAR_JOB_PROPOSAL_ROUTE,
  VIEW_PRICING_ROUTE,
  VIEW_PRINTER_CLIENTS_DETAILS_ROUTE,
  VIEW_PRINTER_CLIENTS_ROUTE,
  VIEW_PRINTER_HISTORY_ROUTE,
  VIEW_PRINTER_JOBS_DETAILS_ROUTE,
  VIEW_PRINTER_JOBS_ROUTE,
  VIEW_PROPOSAL_ROUTE,
  VIEW_REVIEW_JOB_DETAIL_ROUTE,
  VIEW_TECHNICIAN_PROPOSAL_ROUTE,
  VIEW_TEMPLATE_ROUTE,
} from "./routePaths";

const { admin, client, printer, technician } = escConstants.USER_ROLES;
const routes: IRoutes[] = [
  {
    id: 1111111,
    path: TEST_ROUTE,
    component: Test,
    layout: NoLayout,
    isProtected: false,
  },
  {
    id: 1,
    path: NOT_FOUND_ROUTE,
    component: NotFound404,
    layout: NoLayout,
    isProtected: false,
  },
  {
    id: 50,
    path: DASHBOARD_ROUTE,
    component: Dashboard,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 100,
    path: BUILDING_ROUTE,
    component: Building,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: AddBuilding,
        path: ADD_BUILDING_ROUTE,
        id: 101,
      },
      {
        component: ViewBuildingDetails,
        path: VIEW_BUILDING_ROUTE,
        id: 102,
      },
    ],
  },
  {
    id: 200,
    path: HOME_ROUTE,
    component: LandingPage,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 200,
    path: ABOUT_US_ROUTE,
    component: AboutUs,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 2100,
    path: FAQS_ROUTE,
    component: Faqs,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 2200,
    path: CONTACT_US_ROUTE,
    component: ContactUs,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 300,
    path: LOGIN_ROUTE,
    component: Login,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },

  {
    id: 400,
    path: ONBOARDING_ROUTE,
    component: OnBoarding,
    layout: NoLayout,
    isProtected: true,
    children: [
      {
        id: 401,
        path: ONBOARDING_CURRENT_STEP_ROUTE,
        component: OnBoarding,
      },
    ],
  },

  {
    id: 999999,
    path: LOG_OUT_ROUTE,
    component: Logout,
    layout: NoLayout,
    isProtected: false,
  },
  {
    id: 500,
    path: REGISTER_ROUTE,
    component: Register,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 600,
    path: FORGOT_ROUTE,
    component: ForgetPassword,
    layout: NoLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 700,
    path: VERIFICATION_ROUTE,
    component: VerificationCode,
    layout: PrivateLayoutWithNoSidebar,
    isProtected: true,
    redirectToOnAuth: LOGIN_ROUTE,
  },
  {
    id: 800,
    path: PRINTER_ROUTE,
    component: Printer,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: AddPrinter,
        path: ADD_PRINTER_ROUTE,
        id: 801,
      },
    ],
  },
  {
    id: 810,
    path: VIEW_PRINTER_CLIENTS_ROUTE,
    component: PrinterClientList,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 811,
        path: VIEW_PRINTER_CLIENTS_DETAILS_ROUTE,
        component: PrinterClientDetails,
      },
    ],
  },
  {
    id: 820,
    path: VIEW_PRINTER_JOBS_ROUTE,
    component: PrinterJob,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 830,
        path: VIEW_PRINTER_JOBS_DETAILS_ROUTE,
        component: PrinterJobDetails,
      },
    ],
  },
  {
    id: 840,
    path: VIEW_PRINTER_HISTORY_ROUTE,
    component: PrinterHistory,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 900,
    path: CREATE_JOBS_ROUTE,
    component: CreateJobs,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: CreateNewJobs,
        path: ADD_JOBS_ROUTE,
        id: 901,
      },
      {
        component: ViewCreatedJobs,
        path: VIEW_JOBS_ROUTE,
        id: 902,
      },
    ],
  },

  {
    id: 1000,
    path: MY_JOBS_ROUTE,
    component: MyJobs,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: ViewMyJobs,
        path: VIEW_MY_JOBS_ROUTE,
        id: 1001,
      },
    ],
  },
  {
    id: 1200,
    path: MESSAGE_ROUTE,
    component: Message,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    extraInfo: {
      noPadding: true,
    },
  },
  {
    id: 1300,
    path: PROPOSAL_ROUTE,
    component: Proposals,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: JobProposals,
        path: VIEW_PROPOSAL_ROUTE,
        id: 1301,
        children: [
          {
            component: ProposalForTechnician,
            path: VIEW_PARTICULAR_JOB_PROPOSAL_ROUTE,
            id: 1315,
          },
        ],
      },
    ],
  },
  {
    id: 4300,
    path: TECHNICIAN_PROPOSAL_ROUTE,
    component: TechnicianProposals,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: ViewProposal,
        path: VIEW_TECHNICIAN_PROPOSAL_ROUTE,
        id: 4301,
      },
    ],
  },
  {
    id: 1400,
    path: SETTING_ROUTE,
    component: Settings,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 1410,
    path: SETTING_ROUTE,
    component: Settings,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: Rules,
        path: ADMIN_RULES,
        id: 1411,
      },
      {
        component: Country,
        path: ADMIN_COUNTRY,
        id: 1412,
      },
      {
        component: Invoices,
        path: ADMIN_INVOICES,
        id: 1413,
        children: [
          {
            component: SingleInvoice,
            path: ADMIN_INVOICES_VIEW,
            id: 14131,
          },
        ],
      },
    ],
  },
  {
    id: 1420,
    path: USER_ROUTE,
    component: Users,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: UserDetails,
        path: USER_DETAIL_ROUTE,
        id: 14201,
      },
      {
        component: CreateUser,
        path: ADD_USER_ROUTE,
        id: 14202,
      },
    ],
  },
  {
    id: 1430,
    path: TEMPLATE_ROUTE,
    component: Templates,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: AddTemplate,
        path: ADD_TEMPLATE_ROUTE,
        id: 14301,
      },
    ],
  },
  {
    id: 1440,
    path: SYMBOL_ROUTE,
    component: Symbols,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: AddSymbol,
        path: ADD_SYMBOL_ROUTE,
        id: 14401,
      },
    ],
  },
  {
    id: 1500,
    path: BROWSE_JOBS_ROUTE,
    component: BrowseJobs,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        component: BrowseJobsDetails,
        path: VIEW_BROWSE_JOBS_ROUTE,
        id: 1501,
        children: [
          {
            id: 15011,
            path: CREATE_JOB_PROPOSAL_ROUTE,
            component: CreateProposal,
          },
        ],
      },
    ],
  },
  {
    id: 1600,
    path: JOBS_ROUTE,
    component: Jobs,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 1601,
        path: JOBS_DETAILS_ROUTE,
        component: JobDetails,
      },
    ],
  },
  {
    id: 1700,
    path: CONTRACT_ROUTE,
    component: Contract,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 1701,
        path: CONTRACT_DETAILS_ROUTE,
        component: ContractDetails,
      },
    ],
  },
  {
    id: 1800,
    path: SCHEDULE_ROUTE,
    component: Schedule,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 1401,
    path: VIEW_MY_NOTIFICATIONS,
    component: Notifications,
    layout: PrivateLayout,
    isProtected: true,
  },
  {
    id: 1801,
    path: DOWNLOAD_SYMBOLS_ROUTE,
    component: DownloadSymbols,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 1802,
    path: COMPLETE_PDF_ROUTE,
    component: CompletePDF,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 1900,
    path: DOWNLOAD_TEMPLATE_ROUTE,
    component: DownloadTemplate,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 1901,
    path: VIEW_TEMPLATE_ROUTE,
    component: ViewTemplateDetails,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
  },
  {
    id: 2000,
    path: CONTRACT_ROUTE_CLIENT,
    component: ClientContract,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 2001,
        path: CONTRACT_DETAIL_ROUTE_CLIENT,
        component: ClientContractDetails,
      },
    ],
  },
  {
    id: 2002,
    path: REVIEW_ROUTE_ADMIN,
    component: Reviews,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 2004,
        path: VIEW_REVIEW_JOB_DETAIL_ROUTE,
        component: PDFDetail,
        children: [
          {
            id: 20041,
            path: REVIEW_PDF,
            component: ViewReviews,
          },
        ],
      },
    ],
  },
  {
    id: 3000,
    path: TECHNICIAN_ROUTE,
    component: Technicians,
    layout: PrivateLayout,
    isProtected: true,
    allowTo: [admin],
    children: [
      {
        id: 3001,
        path: SINGLE_TECHNICIAN_ROUTE,
        component: TechnicianDetail,
      },
    ],
  },
  {
    id: 4000,
    path: SERVICES_ROUTE,
    component: Services,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 5000,
    path: PRICING_ROUTE,
    component: Pricing,
    layout: PublicLayout,
    isProtected: false,
    redirectToOnAuth: DASHBOARD_ROUTE,
  },
  {
    id: 6000,
    path: CHANGE_PASSWORD_ROUTE,
    component: ChangePassword,
    layout: NoLayout,
  },
  {
    id: 7000,
    path: ADMIN_PRICING_ROUTE,
    component: AdminPricing,
    layout: PrivateLayout,
    isProtected: true,
    redirectToOnAuth: DASHBOARD_ROUTE,
    children: [
      {
        id: 7001,
        path: ADD_PRICING_ROUTE,
        component: AddPricing,
      },
      {
        id: 7002,
        path: VIEW_PRICING_ROUTE,
        component: ViewPricing,
      },
    ],
  },
  {
    id: 8000,
    path: DRAFTS_JOB,
    component: DraftsJob,
    layout: PrivateLayout,
    isProtected: true,
    redirectToOnAuth: DASHBOARD_ROUTE,
    children: [
      {
        id: 8001,
        path: VIEW_DRAFT_JOB_ROUTE,
        component: ViewJob,
      },
    ],
  },
];
export default routes;

export interface IRoutes {
  id: number;
  path: string;
  component: React.FC;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  layout: React.FC<React.PropsWithChildren<{ extraInfo?: any }>>;
  isProtected?: boolean;
  redirectToOnAuth?: string;
  role?: string[];
  restrictTo?: string[];
  allowTo?: string[];
  children?: Array<IChildren>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extraInfo?: any;
}

export interface IChildren {
  id: number;
  path: string;
  component: React.FC;
  children?: Array<IChildren>;
}
